import { Component, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { TableModule } from 'primeng/table';
import { MenuItem, MessageService } from 'primeng/api';
import { AbstractView } from '@core/interfaces';
import { ListPresenter } from './list.presenter';
import { Column, ListViewPresenter } from './interfaces';
import { SharedModule } from '@shared/shared.module';
import { Observable, of } from 'rxjs';
import { PipeEnum } from '@core/enums/pipe.enum';
import { InputSwitchChangeEvent, InputSwitchModule } from 'primeng/inputswitch';
import { Toggle } from '../table/interfaces';
import { Alia } from './interfaces';
import { EventEmitter } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { ReactiveFormsModule } from '@angular/forms';
import { DragDropModule } from 'primeng/dragdrop';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { TableEditCompleteEvent } from 'primeng/table';
import { InputComponent } from '../input/input.component';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-list',
  standalone: true,
  imports: [
    FormsModule,
    SharedModule,
    TableModule,
    InputSwitchModule,
    TableModule,
    ButtonModule,
    ReactiveFormsModule,
    InputTextModule,
    InputNumberModule,
    DragDropModule,
    InputComponent
  ],
  templateUrl: './list.component.html',
  styleUrl: './list.component.scss',
  providers: [ListPresenter],
})
export class ListComponent<T>
  extends AbstractView<ListPresenter<T>>
  implements ListViewPresenter<T>, OnInit
{
  data: T[] = [];
  @Input() loading$: Observable<boolean> = of(false);
  @Input({ required: true }) data$!: Observable<T[] | null>;
  @Input({ required: true }) selectionKey!: string;
  @Input() columns: Column[] = [];
  @Input() alias: Alia[] = [];
  @Input() highlightlastColumn: boolean = true;
  @Input() specialsFields: string[] = [];
  @Output() actionDataEditTriggered = new EventEmitter<T[]>();
  @Output() actionRowEditTriggered = new EventEmitter<TableEditCompleteEvent>();
  @Output() actionToggleTriggered = new EventEmitter<Toggle<T>>();

  pipeEnum = PipeEnum;
  isEnableActionButtons$ = this.presenter.isEnableActionButtons$;

  constructor(
    messageService: MessageService,
    router: Router,
    store: Store,
    presenter: ListPresenter<T>
  ) {
    super(messageService, router, store, presenter);
  }

  ngOnInit(): void {
    this.presenter.setView(this);
  }

  hasMultipleDynamicValues<T extends Record<string, T>>(
    obj: T,
    path: string,
    parentPath: string,
    checkAll: boolean = true,
    expectedValue?: unknown
  ): boolean {
    return this.presenter.hasMultipleDynamicValues(
      obj,
      path,
      parentPath,
      checkAll,
      expectedValue
    );
  }

  getFirstElement<T extends Record<string, T>>(data: T): Record<string, T> {
    return data[0] ?? data;
  }

  isHighlightColumn(index: number): MenuItem | null {
    return this.presenter.isHighlightColumn(index);
  }

  isSpecialField(columns: Column, index: number): MenuItem {
    return this.presenter.isSpecialField(columns, index);
  }

  getDynamicValue<T extends Record<string, T>>(
    obj: T,
    path: string
  ): T | undefined {
    return this.presenter.getDynamicValue(obj, path);
  }

  setDynamicValue<T extends Record<string, T>>(
    row: T,
    path: string,
    value: string
  ): void {
    return this.presenter.setDynamicValue(row, path, value);
  }

  toggleChange(event: InputSwitchChangeEvent, row: T): void {
    this.presenter.toggleChange(event, row);
  }

  onRowEdit(event: TableEditCompleteEvent): void {
    this.presenter.onRowEdit(event);
  }

  onCellEditorKeydown(event: KeyboardEvent): void {
    this.presenter.onCellEditorKeydown(event);
  }

  isNumber(row:T): boolean {
    return this.presenter.isNumber(row)
  }
}
